// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabs_tabContainer__7PgUn","tab":"tabs_tab__1h5-u"};